import * as fabric from 'office-ui-fabric-react';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { getAuthType, logout, useAuthentication } from '../components';

const LogoutPage: FC = () => {
    const navigate = useNavigate();
    const { hasRole } = useAuthentication();
    const authType = getAuthType();

    const checkUserLogged = () => {
        if (hasRole) {
            navigate('/');
        }
    };

    useEffect(() => {
        checkUserLogged();
    }, []);

    return (
        <div style={{ minHeight: '60vh', width: '100%', textAlign: 'center' }} dir="ltr">
            <div className="ms-slideRightIn40" style={{ padding: '80px' }}>
                <fabric.Text
                    style={{
                        fontSize: '50px',
                        fontWeight: 'lighter',
                        color: `${fabric.getTheme().palette.themePrimary}`,
                        paddingTop: '40px',
                        marginTop: '40px'
                    }}
                    variant="xxLargePlus"
                >
                    Eilių valdymo sistemos
                </fabric.Text>
                <br />
                <fabric.Text style={{ fontSize: '90px', color: `${fabric.getTheme().palette.themePrimary}` }} variant="xLarge">
                    NUGIS
                </fabric.Text>
                <br />
                <fabric.Text style={{ fontSize: '50px', fontWeight: 'lighter', color: `${fabric.getTheme().palette.themePrimary}` }} variant="xLarge">
                    portalas
                </fabric.Text>
                <br />
                <br />
                <fabric.Text style={{ fontSize: '30px', fontWeight: 'lighter', color: 'darkred' }} variant="xLarge">
                    Jūs neturite rolės, kreipkitės į administratorių.
                </fabric.Text>
                <br />
                <br />
                <div>
                    {authType === 'Azure' && (
                        <fabric.PrimaryButton
                            onClick={async () => {
                                await logout();
                            }}
                        >
                            <fabric.Text style={{ fontWeight: 'normal' }}>Atsijungti</fabric.Text>
                        </fabric.PrimaryButton>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LogoutPage;
